export default __webpack_public_path__ + "static/media/4.330f082e.jpg";